import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, catchError, combineLatest } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { GuardService } from '@app/services/guard.service';
import { UserService } from '@app/services/user.service';
import { selectTenantData } from '@main-application/store/selectors/user.selectors';
import { AppRoutes } from '@shared/constants/app-routes.const';
import { AuthService } from '@shared/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
    private store: Store<{}>,
    private userService: UserService,
    private guardService: GuardService
  ) {}

  canActivate(): boolean | Observable<boolean | UrlTree> {
    return combineLatest(
      this.userService.getCashedUserData(),
      this.store.select(selectTenantData),
      this.authService.isAuthenticated()
    )
      .pipe(
        filter(([userData, tenantData]) => !!userData && !!tenantData),
        map(([, , isAuthorized]) => {
          if (!isAuthorized) {
            const loginUrlTree = this.router.parseUrl(AppRoutes.LOGIN);
            loginUrlTree.queryParams['returnUrl'] = window.location.href;
            return loginUrlTree;
          }

          return isAuthorized;
        })
      )
      .pipe(catchError(err => this.guardService.handleGuardError(err)));
  }
}
